/*
  Holt die echten Versandkosten fuer den aktuellen Warenkorb bei Shopify und zeigt sie im
  Warenkorb und im Warenkorb-Drawer an, bevor der Kunde in den Checkout geht.

  Warum live und nicht als feste Zahl im Theme: der Shop hat zwei Versandprofile, und bei
  einem gemischten Warenkorb addiert Shopify die Pauschalen (179 + 30 = 209 EUR). Eine
  fest hinterlegte Zahl waere in genau diesen Faellen falsch. Der Endpoint ist derselbe,
  den der eingebaute Versandkostenrechner des Themes benutzt.

  Die Postleitzahl ist fest, weil es nur eine Versandzone gibt (Deutschland). Die Rate ist
  innerhalb der Zone fuer jede PLZ gleich. Kommt eine zweite Zone hinzu, muss hier die
  Adresse des Kunden verwendet oder der Hinweistext angepasst werden.

  Zwei Fallen, die beim Bauen zugeschlagen haben und der Grund fuer die Struktur unten sind:

  1. Der beobachtete Drawer-Footer enthaelt die Ausgabe selbst. Jedes eigene Schreiben hat
     den MutationObserver ausgeloest, der wieder ein Schreiben angestossen hat. Ergebnis war
     eine Dauerschleife im Sekundentakt gegen die Rate-API. Deshalb wird beim Schreiben
     abgekoppelt und zusaetzlich nur gerendert, wenn sich der Warenkorb wirklich geaendert hat.

  2. Bei leerem Warenkorb existiert noch kein Ausgabe-Block. Wer dann aussteigt, legt keine
     Beobachter an und bekommt die erste Artikelzugabe nicht mit. Die Beobachter werden
     deshalb immer angelegt, unabhaengig davon, ob schon ein Block im DOM steht.
*/
(function () {
  'use strict';

  // Das Skript wird an zwei Stellen eingebunden (Warenkorbseite und Header-Drawer).
  // Ein zweiter Aufruf derselben Datei wuerde sonst doppelte Beobachter anlegen.
  if (window.__rgwVersandkosten) return;
  window.__rgwVersandkosten = true;

  var PLZ = '38268';
  var LAND = 'Germany';

  // Format wie im uebrigen Shop: deutsche Trennzeichen, Symbol hinten. Entspricht dem,
  // was der money-Filter in Liquid ausgibt (Beispiel: "1.500,00 €", Shop-Format seit 15.10.2026).
  var zahl = new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  var euro = {
    format: function (betrag) {
      return zahl.format(betrag) + ' €';
    }
  };

  var beobachter = null;
  var letzteSignatur = null;
  var laufend = false;
  var timer = null;

  function alleBloecke() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-rgw-versand-cart]'));
  }

  function json(url) {
    return fetch(url, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (res) {
      if (!res.ok) throw new Error('Status ' + res.status);
      return res.json();
    });
  }

  function beobachten() {
    if (!beobachter) return;
    // Nur Container beobachten, die den Section-Austausch des Themes ueberleben. Auf einem
    // inneren Element wie [data-cart-subtotal] war der Beobachter nach der ersten
    // Mengenaenderung taub, weil das Theme genau dieses Element ersetzt. Im Browser geprueft:
    // #main-cart-footer, #main-cart-items, #header-mini-cart-footer und mini-cart bleiben,
    // ihr Inhalt wird getauscht.
    [
      document.getElementById('main-cart-footer'),
      document.getElementById('main-cart-items'),
      document.getElementById('header-mini-cart-footer'),
      document.querySelector('mini-cart')
    ].forEach(function (ziel) {
      if (ziel) {
        beobachter.observe(ziel, { childList: true, characterData: true, subtree: true });
      }
    });
  }

  // Beim eigenen Schreiben abkoppeln, sonst loest die Ausgabe den Beobachter aus, der sie
  // beobachtet. takeRecords verwirft die waehrenddessen aufgelaufenen Meldungen.
  function schreibe(fn) {
    if (beobachter) beobachter.disconnect();
    try {
      fn();
    } finally {
      if (beobachter) {
        beobachter.takeRecords();
        beobachten();
      }
    }
  }

  function guenstigsteRate(rates) {
    if (!rates || !rates.length) return null;
    return rates.reduce(function (min, rate) {
      var preis = parseFloat(rate.price);
      if (isNaN(preis)) return min;
      if (!min || preis < min.preis) return { preis: preis, name: rate.name };
      return min;
    }, null);
  }

  function rendern(block, warenwert, rate) {
    var wert = block.querySelector('[data-rgw-versand-wert]');
    var gesamtZeile = block.querySelector('[data-rgw-versand-gesamt]');
    var gesamtWert = block.querySelector('[data-rgw-gesamt-wert]');
    if (!wert) return;

    wert.classList.remove('is-laedt', 'is-frei');

    if (!rate) {
      // Keine Rate ermittelbar: eine ehrliche Angabe statt einer falschen oder leeren Zahl.
      wert.textContent = 'an der Kasse';
      if (gesamtZeile) gesamtZeile.hidden = true;
      return;
    }

    if (rate.preis === 0) {
      wert.textContent = 'kostenlos';
      wert.classList.add('is-frei');
    } else {
      wert.textContent = euro.format(rate.preis);
    }

    if (gesamtZeile && gesamtWert && typeof warenwert === 'number') {
      gesamtWert.textContent = euro.format(warenwert / 100 + rate.preis);
      gesamtZeile.hidden = false;
    }
  }

  function aktualisieren() {
    if (laufend) return;
    if (!alleBloecke().length) return;
    laufend = true;

    var query =
      '/cart/shipping_rates.json?shipping_address%5Bcountry%5D=' +
      encodeURIComponent(LAND) +
      '&shipping_address%5Bzip%5D=' +
      encodeURIComponent(PLZ) +
      '&shipping_address%5Bprovince%5D=';

    json('/cart.js')
      .then(function (korb) {
        if (!korb || korb.item_count === 0) {
          letzteSignatur = null;
          return null;
        }

        // Nur holen, wenn sich der Warenkorb wirklich geaendert hat. Das haelt die
        // Schleife aus Beobachter und eigener Ausgabe zuverlaessig zu.
        var signatur = korb.item_count + ':' + korb.total_price;
        var schonGerendert = alleBloecke().every(function (block) {
          return block.dataset.rgwSignatur === signatur;
        });
        if (signatur === letzteSignatur && schonGerendert) return null;

        return json(query).then(function (raten) {
          var rate = guenstigsteRate(raten.shipping_rates);
          schreibe(function () {
            alleBloecke().forEach(function (block) {
              rendern(block, korb.total_price, rate);
              block.dataset.rgwSignatur = signatur;
            });
          });
          letzteSignatur = signatur;
          return null;
        });
      })
      .catch(function () {
        schreibe(function () {
          alleBloecke().forEach(function (block) {
            rendern(block, null, null);
          });
        });
      })
      .then(function () {
        laufend = false;
      });
  }

  function angestossen() {
    clearTimeout(timer);
    timer = setTimeout(aktualisieren, 500);
  }

  function start() {
    if ('MutationObserver' in window && !beobachter) {
      beobachter = new MutationObserver(angestossen);
      beobachten();
    }

    document.addEventListener('cart:updated', angestossen);
    document.addEventListener('cart:refresh', angestossen);

    aktualisieren();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
